const selectors = [
    '.shopify-section--image-with-text-overlay .prose',
    '.shopify-section--rich-text .prose',
    '.shopify-section--collection-list .shopify-block',
    '.shopify-section--featured-collections .featured-collections-header',
    '.shopify-section--featured-collections .product-card',
    '.shopify-section--newsletter .container',
    '.product .product-gallery',
    '.product .product-info__block-list .product-info__block-item',
    '.shopify-section--faq .section-header',
    '.shopify-section--faq .accordion',
    '.shopify-section--featured-product-list .container',
    '.shopify-section--specifications .section-split__column',
    '.shopify-section--multi-column .container',
    '.shopify-section--before-after-image .container',
    '.shopify-section--products-with-image .products-with-image__image-wrapper',
    '.shopify-section--products-with-image .product-card',
    '.shopify-section--blog-post-banner .content-box',
    '.shopify-section--media-blocks media-blocks',
    '.shopify-section--text-with-media .section-split__column',
    '.shopify-section--blog-posts .section-headern',
    '.shopify-section--blog-posts .floating-controls-container',
    '.shopify-section--contact .prose',
    '.shopify-section--contact .social-media',
    '.shopify-section--contact .form',
    '.shopify-section--text-with-icons .section-header',
    '.shopify-section--text-with-icons .text-with-icons',
    '.shopify-section--text-with-icons .scroll-marker-group',
    '.shopify-section--testimonials .testimonials',
    '.shopify-section--dynamic-grid .dynamic-grid__cell',
    '.shopify-section--links-with-image .section-split',
    '.shopify-section--links-with-image .container'
];
const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            const elem = entry.target;
            observer.unobserve(elem);
            elem.classList.add('is-visible');
        }
    });
});
const targets = document.querySelectorAll(selectors.join(', '));
targets.forEach((elem) => {
    observer.observe(elem);
});